import React from 'react';
import './SignUpMembers.css'
import SignUpMembersFinal from '../../components/SignUpMembersFinal'
import { connect } from 'react-redux'
import { Field, reduxForm , getFormSyncErrors, getFormValues} from 'redux-form';
import * as Validator from '../../utils/helpers/validationPassword';

const renderField = ({ input, label, type, meta: { touched, error } }) => (
    <div className="aps-section-register-fields-container" data-uk-grid>
        <div className="uk-width-1-4@m aps-section-register-fields-left"></div>
        <div className="uk-width-expand@m aps-section-register-fields-center-inscription uk-text-center">
            <p className="uk-text-left aps-section-contacter-fields-name">{label}</p>
            <div className="uk-inline aps-section-register-fields-full">
                {(type === 'select') ?
                    <select
                        {...input}
                        className={(touched && error) ? "uk-select aps-section-register-fields aps-section-register-fields-required" : "uk-select aps-section-register-fields"}
                        placeholder={label}
                    >
                        <option value="">{label}</option>
                        <option value="monsieur">Monsieur</option>
                        <option value="madame">Madame</option>
                    </select>
                    :
                    <input
                        {...input}
                        className={(touched && error) ? "uk-input aps-section-register-fields aps-section-register-fields-required" : "uk-input aps-section-register-fields"}
                        type={type}
                        placeholder={label}
                    />
                }
            </div>
            <p className="uk-text-left aps-section-register-fields-required-alert">{touched && error && (error)}</p>
        </div>
        <div className="uk-width-1-4@m aps-section-register-fieldvaluess-right">

        </div>
    </div>
)

const validate = (values, props) => {
    const errors = {
      passValidLength: false,
      passHasLowCase: false,
      passHasUpperCase: false,
      passHasUpperNuber: false
    }
    let invalidPassMsg = 'Vous devez respecter la syntaxe du mot de passe'
    if (Validator.isEmpty(values.civility)) {
        errors.civility = 'Vous devez choisir une civilité'
    }
    if (!values.firstname) {
        errors.firstname = 'Vous devez entrez un nom'
    }
    if (!values.lastname) {
        errors.lastname = 'Vous devez entrez un prénom'
    }
    if (!values.telephone) {
        errors.telephone = 'Vous devez entrez un numéro'
    }
    if (!values.passwordFirst) {
        errors.passwordFirst = 'Vous devez entrez un mot de passe'
    } else {

        if (Validator.verifyPasswordChar(values.passwordFirst)) {
            errors.passValidLength = true
        } else {
            errors.passwordFirst = invalidPassMsg
        }
        if (Validator.verifyPasswordLowcase(values.passwordFirst)) {
            errors.passHasLowCase = true
        } else {
            errors.passwordFirst = invalidPassMsg
            errors.passHasLowCase = false
        }
        if (Validator.verifyPasswordUppercase(values.passwordFirst)) {
            errors.passHasUpperCase = true

        } else {
            errors.passwordFirst = invalidPassMsg
        }
        if (Validator.verifyPasswordNumber(values.passwordFirst)) {
            errors.passHasUpperNuber = true
        } else {
            errors.passwordFirst = invalidPassMsg
        }
    }
    if (!values.password) {
        errors.password = 'Vous devez confirmer le mot de passe'
    } else if (values.passwordFirst !== values.password) {
        errors.password = 'Les mots de passe ne correspondent pas'
    }
    if (!values.email) {
        errors.email = 'Vous devez entrer une adresse mail'
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
        errors.email = "Cet adresse email n'est pas valide"
    }
    return errors
}

let ReduxSignUpForm = (props) => {
    const { signUpMembers, handleSubmit, FormSyncErrors, invalid , NotificationSignUpMembersError, signUpMembersIsError} = props;
    let { FormValues} = props;
    FormValues  = FormValues || {}
    return (
        <div>
            <div className="aps-container-center-bloc">
                {signUpMembers.isLoading
                    ?
                      <div className="aps-spinner-container-loading">
                        <div className="uk-spinner">
                          <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 30 30" ratio="1">
                             <circle fill="none" stroke="#AEC340" cx="15" cy="15" r="14"></circle>
                          </svg>
                        </div>
                        <div className="aps-section-register-desc">chargement en cours</div>
                      </div>
                    :
                    <div>
                        {Object.keys(signUpMembers.userData).length !== 0
                            ?
                            <div>
                              <SignUpMembersFinal userData={signUpMembers.userData} />
                            </div>
                            :
                            <div className="aps-section-connexion-padding">
                                <div className="uk-section aps-section-register">
                                    <h1 className="uk-text-center aps-section-register-title">
                                        Veuillez compléter les champs suivants pour créer votre compte
                                      </h1>
                                    <div className="uk-text-center aps-section-register-desc">
                                        Le compte est sans engagement et vous permet de sauvergarder
                                        vos informations de souscription pour y revenir quand vous
                                        le souhaitez
                                    </div>
                                </div>
                                {/*Contenu du formulaire*/}
                                <form onSubmit={handleSubmit}>
                                    <div className="aps-section-register-content">

                                        {/*Champs civilité*/}
                                        <Field name="civility" type="select" label="Civilité" component={renderField} />

                                        {/*Champs nom*/}
                                        <Field name="firstname" type="text" label="Nom" component={renderField} />

                                        {/*Champs prenom*/}
                                        <Field name="lastname" type="text" label="Prénom" component={renderField} />

                                        {/*Champs email*/}
                                        <Field name="email" type="email" label="Email" component={renderField} />

                                        {/*Champs telephone*/}
                                        <Field name="telephone" type="text" label="Numéro de téléphone" component={renderField} />

                                        {/*Champs mot de passe*/}
                                        <Field name="passwordFirst" type="password" label="Mot de passe" component={renderField} />

                                        {/*Champs confirmer mot de passe*/}
                                        <Field name="password" type="password" label="Confirmer le mot de passe" component={renderField} />

                                        {/*Alerte validation mot de passe*/}
                                        <div className="uk-text-center aps-section-register-alert-container">
                                            <div className="uk-inline aps-section-register-fields-alert-content">
                                                <div className="uk-child-width-1-2 aps-register-alert" data-uk-grid>
                                                    <div className="uk-text-left aps-register-alert-col-first">
                                                        <div>
                                                            <i
                                                                className={(FormValues.passwordFirst && FormSyncErrors.passValidLength && "fa fa-check aps-register-notification-verifed") || (FormValues.passwordFirst && !FormSyncErrors.passValidLength && "fa fa-times aps-register-notification-verifed-no") || ("fa fa-circle aps-register-notification")}>
                                                            </i>

                                                            <span className="aps-register-notification-msg">Au moins 08 caratères</span>
                                                        </div>
                                                    </div>
                                                    <div className="uk-text-left aps-register-alert-col-second">
                                                        <div>
                                                            <i className={(FormValues.passwordFirst && FormSyncErrors.passHasLowCase && "fa fa-check aps-register-notification-verifed") || (FormValues.passwordFirst && !FormSyncErrors.passHasLowCase && "fa fa-times aps-register-notification-verifed-no") || ("fa fa-circle aps-register-notification")}
                                                            >
                                                            </i>
                                                            <span className="aps-register-notification-msg">Au moins une lettre miniscule</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="uk-child-width-1-2 aps-register-alert" data-uk-grid>
                                                    <div className="uk-text-left aps-register-alert-col-first">
                                                        <div>
                                                            <i className={(FormValues.passwordFirst && FormSyncErrors.passHasUpperCase && "fa fa-check aps-register-notification-verifed") || (FormValues.passwordFirst && !FormSyncErrors.passHasUpperCase && "fa fa-times aps-register-notification-verifed-no") || ("fa fa-circle aps-register-notification")}
                                                            >
                                                            </i>
                                                            <span className="aps-register-notification-msg">Au moins une lettre majuscule</span>
                                                        </div>
                                                    </div>
                                                    <div className="uk-text-left aps-register-alert-col-second">
                                                        <div>
                                                            <i className={(FormValues.passwordFirst && FormSyncErrors.passHasUpperNuber && "fa fa-check aps-register-notification-verifed") || (FormValues.passwordFirst && !FormSyncErrors.passHasUpperNuber && "fa fa-times aps-register-notification-verifed-no") || ("fa fa-circle aps-register-notification")}
                                                            >
                                                            </i>
                                                            <span className="aps-register-notification-msg">Au moins un chiffre</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/*button soumettre le formulaire*/}
                                        <div className="uk-text-center aps-section-register-action-btn">
                                            <button
                                              type="submit"
                                              className={`uk-button aps-section-register-action-btn-full ${invalid ? 'aps-section-register-action-btn-no-active apply-disabled-btn' : ''}`}
                                              disabled={invalid}
                                            >S&apos;inscrire</button>
                                        </div>

                                        {/*Erreur pour se connecter*/}
                                        {signUpMembersIsError &&
                                          <div>
                                            { NotificationSignUpMembersError() }
                                          </div>
                                        }
                                    </div>
                                </form>
                                {/*Contenu du formulaire*/}
                            </div>
                        }
                    </div>
                }
            </div>

        </div>
    )
}

const mapStateToProps = state => ({
    FormSyncErrors: getFormSyncErrors('ReduxSignUpForm')(state),
    FormValues: getFormValues('ReduxSignUpForm')(state),
  });

  export default connect(mapStateToProps)(
    reduxForm({
        form: 'ReduxSignUpForm',
        validate

    })(ReduxSignUpForm)
  );



// WEBPACK FOOTER //
// ./src/containers/SignUpMembers/SignUpMembersForm.js